export default "__VITE_ASSET__BVHZbpab__"